export const industryServiceData = [
  {
    industry: "Information Technology & Services",
    services: [
      "Software Development",
      "Web Development",
      "Cybersecurity",
      "Cloud Computing",
      "IT Consulting",
      "Data Analytics & Artificial Intelligence",
      "Enterprise Software Solutions",
      "Network Administration & Infrastructure",
      "Technical Support & Managed IT"
    ],
  },
  {
    industry: "Healthcare & Medical",
    services: [
      "General Medical & Healthcare",
      "Telemedicine & Virtual Health Consultations",
      "Mental Health Counseling & Therapy",
      "Dental & Orthodontic",
      "Physical Therapy & Rehabilitation",
      "Home Healthcare & Nursing",
      "Medical Research & Clinical Trials",
      "Nutrition & Diet Planning",
      "Alternative Medicine & Holistic Health",
      "Veterinary"
    ],
  },
  {
    industry: "Finance & Banking",
    services: [
      "Banking & Investment Management",
      "Financial Technology (FinTech)",
      "Credit & Loan Services",
      "Stock Trading & Brokerage",
      "Payment Processing & Merchant Solutions"
    ],
  },
  {
    industry: "Education & E-learning",
    services: [
      "Private Tutoring & Exam Preparation",
      "E-learning & Online Course Development",
      "Corporate Training & Employee Development",
      "Language Translation & Interpretation",
      "Study Abroad & Student Counseling",
      "Career Coaching & Resume Writing",
      "Special Education & Learning Support",
      "Test Proctoring & Certification",
      "College Admissions & Scholarship Consulting",
      "Research & Academic Writing Support"
    ],
  },
  {
    industry: "Manufacturing & Industrial",
    services: [
      "General Manufacturing & Production",
      "Custom Manufacturing & Prototyping",
      "Industrial Automation & Robotics",
      "Welding & Fabrication",
      "Safety Inspections & Environmental Compliance"
    ],
  },
  {
    industry: "Retail & E-commerce",
    services: [
      "Retail Store Management & Operations",
      "E-commerce & Online Store Setup",
      "Dropshipping & Fulfillment",
      "Personal Shopping & Styling",
      "Product Design & Packaging",
      "Customer Support & Call Center",
      "Subscription Box & Membership"
    ],
  },
  {
    industry: "Marketing & Advertising",
    services: [
      "Branding & Graphic Design",
      "Digital Marketing (SEO, SEM, PPC)",
      "Social Media Management",
      "Content Writing & Copywriting",
      "Video Production & Animation",
      "Event Planning & Management",
      "Advertising & Media Buying",
      "Photography & Videography",
      "Public Speaking & Presentation Coaching",
      "Podcast & Audio Production"
    ],
  },
  {
    industry: "Construction & Engineering",
    services: [
      "General Contracting & Construction",
      "Civil Engineering & Structural Design",
      "Electrical & Plumbing",
      "HVAC Installation & Maintenance",
      "Land Surveying & Appraisal",
      "Architecture & Urban Planning",
      "Landscaping & Outdoor Design",
      "Heavy Equipment Rental & Leasing"
    ],
  },
  {
    industry: "Hospitality & Tourism",
    services: [
      "Travel Agency & Tour Planning",
      "Hotel & Resort Management",
      "Flight & Accommodation Booking Assistance",
      "Destination Wedding & Honeymoon Planning",
      "Luxury Concierge & VIP Travel",
      "Adventure & Eco-Tourism",
      "Cruise & Yacht Chartering",
      "Airport Transfers & Chauffeur",
      "Food & Culinary Tourism Experiences",
      "Theme Park & Attraction Management"
    ],
  },
  {
    industry: "Real Estate",
    services: [
      "Real Estate Brokerage & Property Sales",
      "Property Management & Leasing",
      "Home Staging & Interior Design",
      "Mortgage & Home Loan Advisory",
      "Commercial Real Estate Consulting",
      "Home Inspection & Valuation",
      "Moving & Relocation",
      "Short-Term Rentals & Vacation Property Management"
    ],
  },
  {
    industry: "Transportation & Logistics",
    services: [
      "Freight & Logistics Management",
      "Trucking & Delivery",
      "Fleet Management & Tracking",
      "Public Transportation Planning",
      "Ridesharing & Taxi",
      "Bicycle & Scooter Rentals"
    ],
  },
  {
    industry: "Legal & Law",
    services: [
      "Legal Advisory & Litigation",
      "Corporate & Intellectual Property Law",
      "Immigration & Visa Assistance",
      "Notary & Documentation"
    ],
  },
  {
    industry: "Media & Entertainment",
    services: [
      "Live Event & Concert Production",
      "DJ & Music Production",
      "Performing Arts & Talent Management",
      "Amusement Park & Entertainment Venue Operations",
      "Gaming & Esports Coaching",
      "Fine Art Curation & Sales",
      "Photography & Film Production",
      "Outdoor Adventure & Sports Coaching",
    ],
  },
  {
    industry: "Energy & Utilities",
    services: [
      "Renewable Energy Solutions",
      "Oil & Gas Exploration",
      "Water Treatment & Waste Management",
      "Electricity Distribution & Grid Management",
    ],
  },
  {
    industry: "Telecommunications",
    services: [
      "Internet & Broadband",
      "Satellite Communications",
      "Wireless Network & Mobile Services",
      "Telecom Infrastructure & Consulting",
    ],
  },
  {
    industry: "Government & Public Administration",
    services: [
      "Public Policy & Governance",
      "Civic & Community Engagement",
      "Emergency & Disaster Response",
    ],
  },
  {
    industry: "Automotive",
    services: [
      "Vehicle Sales & Leasing",
      "Auto Repair & Maintenance",
      "Car Wash & Detailing",
      "Driving Lessons & Defensive Driving Training",
    ],
  },
  {
    industry: "Consumer Goods",
    services: [
      "Product Development & Manufacturing",
      "Retail Distribution & Sales",
    ],
  },
  {
    industry: "Biotechnology & Pharmaceuticals",
    services: [
      "Drug Development & Research",
      "Medical Device Manufacturing",
      "Pharmaceutical Distribution",
    ],
  },
  {
    industry: "Aerospace & Defense",
    services: [
      "Aircraft Manufacturing & Maintenance",
      "Military & Defense Technology",
    ],
  },
  {
    industry: "Agriculture & Farming",
    services: [
      "Crop & Livestock Production",
      "Agricultural Machinery & Equipment",
    ],
  },
  {
    industry: "Sports & Recreation",
    services: [
      "Sports Coaching & Training",
      "Recreational Facility Management",
    ],
  },
  {
    industry: "Nonprofit & Social",
    services: ["Charity & Fundraising", "Community Development & Outreach"],
  },
  {
    industry: "Mining & Metals",
    services: [
      "Mineral Exploration & Extraction",
      "Metal Processing & Refining",
    ],
  },
  {
    industry: "Insurance",
    services: ["Health & Life Insurance", "Auto & Property Insurance"],
  },
  {
    industry: "Human Resources & Staffing",
    services: [
      "Employee Training & Development",
      "Payroll & Benefits Management",
    ],
  },
  {
    industry: "Environmental",
    services: ["Sustainability & Conservation", "Recycling & Waste Management"],
  },
  {
    industry: "Food & Beverage",
    services: ["Restaurant & Catering", "Food Processing & Manufacturing"],
  },
  {
    industry: "Research & Development",
    services: [
      "Scientific & Technological Research",
      "Product Innovation & Prototyping",
    ],
  },
];
